import type { Chain } from "@opensea/app-kit"
import { getChainRpcUrls } from "@opensea/app-kit"
import type { Chain as ViemChain } from "viem"

/**
 * Converts an app-kit Chain to a Viem Chain for use with wagmi/viem-specific contexts
 */
export function toViemChain(chain: Chain): ViemChain {
  const rpcUrls = getChainRpcUrls(chain)

  return {
    id: chain.networkId,
    name: chain.name,
    nativeCurrency: {
      name: chain.nativeCurrency.name,
      symbol: chain.nativeCurrency.symbol,
      decimals: chain.nativeCurrency.decimals,
    },
    rpcUrls: {
      default: {
        http: rpcUrls.length > 0 ? rpcUrls : [""],
      },
    },
    blockExplorers: {
      default: {
        name: chain.blockExplorer.name,
        url: chain.blockExplorer.url,
      },
    },
  }
}

// Re-export for convenience
export { getChainRpcUrls }
